import * as React from 'react';
import { EditOutlined, LeftOutlined, FormOutlined } from '@ant-design/icons';
import { Input, Popover, Space } from 'antd';
import { Link, match } from 'react-router-dom';
import {
  UserContextProps,
  OrgContextProps,
  AgentContextProps,
  AgentContext,
  UserContext,
  OrgContext,
  OrgInfo
} from '@interface/index';
import '@style/component/header.less';
import {
  AGENT_LAN,
  blueColor,
  contentFontColor,
  NiCommonCascader,
  SELECTION_KEY,
  SelectionOption
} from '@config/index';
import { NiBreadcrumb, NiInput } from '@component/index';
import { localizedString } from '@locale/index';
import { isEqual, getOrgId, getAgentId } from '@lib/index';

export enum CommonBreadcrumbItem {
  user = 'user',
  org = 'org',
  agent = 'agent',
  frame = 'frame'
}

export interface HeaderCommonPropsConfig {
  className?: string;
  onRef?: (ref: HeaderComp) => void;
  items?: CommonBreadcrumbItem[];
  extra?: React.ReactNode;
  match: match<any>;
  extraBreadcrumbs?: { to: string; title: string; text?: boolean }[];
  cur?: string;
  backExtra?: string;
  titlePrefix?: string;
  noSlash?: boolean;
  title: string;
  titleSuffix?: string;
  defaultTitle?: string;
  titleExtra?: string | JSX.Element;
  isEdit?: boolean;
  placeHolder?: string;
  onBackClick?: () => void;
  onTitleClick?: () => void;
  onTitleChanged?: (title: string) => void;
  onLevelChanged?: (level: number) => void;
  onBlur?: (title: string) => void;
}
export type HeaderPropsConfig = AgentContextProps &
  UserContextProps &
  OrgContextProps &
  HeaderCommonPropsConfig;
export interface HeaderStateConfig {
  editting?: boolean;
  structId?: string;
  title?: string;
}

export class HeaderComp extends React.Component<HeaderPropsConfig, HeaderStateConfig> {
  public state: HeaderStateConfig = {};

  public focusInput() {
    this.setState({ editting: true });
  }
  constructor(props: HeaderPropsConfig) {
    super(props);

    this.state = {
      editting: false
    };
  }

  componentDidUpdate(prevProp: HeaderPropsConfig, prevState: HeaderStateConfig) {
    if (!isEqual(prevProp, this.props)) {
      this.onInit();
    }
  }

  onInit = () => {

    const { agent } = this.props;

    let structId: string | undefined;

    if (agent) {
      if (agent.language === AGENT_LAN.STRUCT) {
        structId = agent.id;
      } else if (agent.structKey) {
        structId = agent.structKey.agentId;
      }
    }

    this.setState({
      structId,
      title: this.props.title
    });
  }

  componentDidMount() {
    if (this.props.onRef) {
      this.props.onRef(this);
    }
    this.onInit();
  }
  render() {
    const {
      className,
      extra,
      backExtra,
      titlePrefix,
      noSlash,
      titleSuffix,
      onBackClick,
      onTitleChanged,
      onBlur,
      onTitleClick
    } = this.props;

    const { structId, title } = this.state;

    return (
      <header className={`layout__header body-header ${className}`}>
        <div className="breadcrumb__wrap">
          <div className="title-area" title={this.props.title}>
            <Space key="title-area-space">
              {onBackClick &&
                <LeftOutlined key="back" className="back-btn" style={{ marginRight: 8 }} onClick={() => {
                  onBackClick();
                }} />
              }
              {
                onBackClick && backExtra &&
                <span>
                  <span key="back-extra" className="back-extra" style={{ cursor: 'pointer', color: blueColor }} onClick={onBackClick}>{backExtra}</span>
                </span>
              }
              {titlePrefix &&
                <span>
                  <span key="title-prefix" className="title-prefix" style={{ color: contentFontColor }}>{titlePrefix}</span> {noSlash ? '' : '/'}
                </span>
              }
              {!this.state.editting && (
                <div key="title" className="title" style={{ cursor: onTitleClick ? 'pointer' : 'inherit' }} onClick={onTitleClick}>
                  {this.state.title || this.props.defaultTitle || this.props.cur}
                </div>
              )}
              {!this.state.editting && this.props.titleSuffix && (
                <div key="title-suffix" className="title-suffix">
                  {titleSuffix}
                </div>
              )}
              {!this.state.editting && this.props.isEdit && (
                <FormOutlined
                  key="title-edit"
                  onClick={() => {
                    this.setState({
                      editting: true
                    });
                  }} />
              )}
              {!this.state.editting && this.props.titleExtra}
              {this.state.editting && (
                <Popover
                  key="title-popover"
                  content={this.props.placeHolder || localizedString('common_name_placeholder')}
                  visible={false}
                >
                  <NiInput
                    key="name-input"
                    ref={(input: any) => {
                      if (input) {
                        input.focus();
                      }
                    }}
                    value={this.state.title}
                    placeholder={this.props.placeHolder || ''}
                    onPressEnter={(e: any) => {
                      this.setState({
                        editting: false
                      });

                      if (onBlur) {
                        onBlur(this.props.title);
                      }
                    }}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                      const nextTitle = e.target.value;
                      if (onTitleChanged && nextTitle !== this.state.title) {
                        onTitleChanged(nextTitle);
                      }
                      this.setState({ title: nextTitle });
                    }}
                    onBlur={() => {
                      this.setState({
                        editting: false
                      });

                      if (onBlur) {
                        onBlur(this.props.title);
                      }
                    }}
                  />
                </Popover>
              )}
              {this.state.editting && this.props.titleSuffix && (
                <div key="title-suffix" className="title-suffix">
                  {titleSuffix}
                </div>
              )}
            </Space>
            <div className="extra__wrap">{extra}</div>
          </div>

        </div>
      </header >
    );
  }
}

export const Header = (props: HeaderCommonPropsConfig) => (
  <AgentContext.Consumer>
    {($agent: AgentContextProps) => (
      <OrgContext.Consumer>
        {($org: OrgContextProps) => (
          <UserContext.Consumer>
            {($data: UserContextProps) => (
              <HeaderComp {...props} {...$data} {...$org} {...$agent} />
            )}
          </UserContext.Consumer>
        )}
      </OrgContext.Consumer>
    )}
  </AgentContext.Consumer>
);
